import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ButtonIconos } from "../../ui";
import TooltipLogBlock from "../../../tooltip/TooltipLogBlock";
import {
  SvgEditarUsuario,
  SvgFactura,
  SvgGanancias,
  SvgIdentificate,
  SvgSalir,
  SvgSuscripcion,
} from "../../../icons";
import EligeEmpresa from "./EligeEmpresa";
import { useAuthToken } from "../../../hooks/useAuthToken";

interface LogBlockProps {
  className?: string;
  desbloquearDniNie?: () => void;
  onLogout?: () => void;
}

const LogBlock: React.FC<LogBlockProps> = ({
  className = "",
  desbloquearDniNie,
  onLogout,
}) => {
  const navigate = useNavigate();
  const { token, roles, clearToken } = useAuthToken();

  // 🔥 NORMALIZACIÓN MULTI-ROL REAL
  const normalizedRoles = roles.map(r =>
    r.replace(/^role_/i, "")
      .replace(/^role/i, "")
      .trim()
      .toLowerCase()
  );;

  const isAdmin =
    normalizedRoles.includes("admin") ||
    normalizedRoles.includes("superadmin");

  const isProfesional = normalizedRoles.includes("profesional");
  const isAfiliado = normalizedRoles.includes("afiliado");
  const isUsuario = normalizedRoles.includes("usuario");
  const canSeeSuscripcion = isProfesional || isUsuario || isAdmin;
  const handleLogout = () => {
    clearToken();
    onLogout?.();
    setTimeout(() => navigate("/"), 300);
  };

  return (
    <div className={`flex flex-wrap items-center justify-center gap-2 px-2 ${className}`}>
      {!token ? (
        <Link to="/sign">
          <TooltipLogBlock className="hidden sm:block" label="Entrar">
            <ButtonIconos>
              <SvgIdentificate />
            </ButtonIconos>
          </TooltipLogBlock>
        </Link>
      ) : (
        <>
          {/* ADMIN */}
          {isAdmin && (
            <Link to="/">
              <TooltipLogBlock label="Inicio">
                <ButtonIconos>
                  <SvgIdentificate className="text-green-400" />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {isAdmin && (
            <Link to="/backoffice">
              <TooltipLogBlock label="Backoffice">
                <ButtonIconos>
                  <SvgIdentificate className="text-blue-400 rotate-180" />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* PROFESIONAL */}
          {isProfesional && (
            <>
              <Link to="/contratosFacturas">
                <TooltipLogBlock label="Contratos y Facturas">
                  <ButtonIconos>
                    <SvgFactura />
                  </ButtonIconos>
                </TooltipLogBlock>
              </Link>

              <EligeEmpresa />
            </>
          )}

          {/* LOGUEADOS */}
          {(isProfesional || isAfiliado || isUsuario || isAdmin) && (
            <Link to="/editaUsuario">
              <TooltipLogBlock label="Editar usuario">
                <ButtonIconos>
                  <SvgEditarUsuario />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* AFILIADO */}
          {(isAfiliado || isAdmin) && (
            <Link to="/panelAfiliado">
              <TooltipLogBlock label="Monetización">
                <ButtonIconos>
                  <SvgGanancias />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* SUSCRIPCIÓN */}
          {canSeeSuscripcion && (
            <Link to="/suscribirse" onClick={() => desbloquearDniNie?.()}>
              <TooltipLogBlock label="Suscripción profesional">
                <ButtonIconos>
                  <SvgSuscripcion />
                </ButtonIconos>
              </TooltipLogBlock>
            </Link>
          )}

          {/* LOGOUT */}
          <TooltipLogBlock
            label="Salir"
            className="border-red-500 border-2 rounded-md shadow-sm shadow-red-500"
          >
            <ButtonIconos onClick={handleLogout} className="hover:rounded-sm">
              <SvgSalir className="text-red-600" />
            </ButtonIconos>
          </TooltipLogBlock>
        </>
      )}
    </div>
  );
};

export default LogBlock;
